import { QarepaEnumInformation } from '@qarepa/common';

export enum ColorEnum {
  BLUE = '#bfdbfe',
  GREEN = '#bbf7d0',
  ORANGE = '#fed7aa',
  RED = '#fecdd3',
  YELLOW = '#fde68a',
}

export const ColorArray = [
  ColorEnum.BLUE,
  ColorEnum.GREEN,
  ColorEnum.ORANGE,
  ColorEnum.RED,
  ColorEnum.YELLOW,
];

export const ColorInfo: QarepaEnumInformation<ColorEnum> = {
  [ColorEnum.BLUE]: {
    name: $localize`Azul`,
  },
  [ColorEnum.GREEN]: {
    name: $localize`Verde`,
  },
  [ColorEnum.ORANGE]: {
    name: $localize`Naranja`,
  },
  [ColorEnum.RED]: {
    name: $localize`Rojo`,
  },
  [ColorEnum.YELLOW]: {
    name: $localize`Amarillo`,
  },
};
